<script lang="ts">
export default { name: "GalleryImage" };
</script>

<script setup lang="ts">
import { ref, PropType } from "vue";
import { ModalContainerVue } from ".";
import type { GalleryImage } from "@/models/gallery";

defineProps({
	image: {
		type: Object as PropType<GalleryImage>,
		required: true
	}
});

const modalRef = ref<InstanceType<typeof ModalContainerVue>>();

const onImageClick = () => {
	modalRef.value?.show();
};
</script>

<template>
	<div class="gallery-image-container" @click="onImageClick">
		<img :src="image.thumbUrl" :alt="image.filename" />
	</div>

	<ModalContainerVue ref="modalRef">
		<img :src="image.fullUrl" :alt="image.filename" loading="lazy" />
	</ModalContainerVue>
</template>

<style scoped lang="scss">
.gallery-image-container {
	cursor: pointer;
	display: block;
	position: relative;
	transition: transform 0.25s ease-out;
}

.gallery-image-container:hover {
	transform: scale(1.03);
}

.gallery-image-container > img {
	box-shadow: 0 0.3em 2em rgba(0, 0, 0, 0.25);
	width: 100%;
}
</style>
